import ProfileDetailsModal from './components/profileDetailsModal/ProfileDetailsModal';
import HomeBannerCarousel from './components/homeBannerCarousel/HomeBannerCarousel';
import StoriesBar from './components/storiesBar/StoriesBar';
import CategoryScroll from './components/categoryScroll/CategoryScroll';
import HomeLoungeMood from './components/homeLoungeMood/HomeLoungeMood';
import HomePersonGrid from './components/homePersonGrid/HomePersonGrid';
import { useHomePersons } from './hooks/useHomePersons';
import { HomeView } from './home.styles';

const Home = () => {
	const {
		storyPersons,
		filteredPersons,
		tags,
		isTagsLoading,
		selectedProfile,
		setSelectedProfile,
		activeCategory,
		setActiveCategory,
		handleReloadImage,
		handleCloseProfile,
		loadNextPage,
		handleSurprise,
		hasMore,
		isStoriesLoading,
		isLoadingMore,
	} = useHomePersons();

	return (
		<>
			{selectedProfile && <ProfileDetailsModal profile={selectedProfile} onClose={handleCloseProfile} />}
			<HomeView id="homeView" data-view="home">
				<HomeBannerCarousel />
				<StoriesBar persons={storyPersons} isLoading={isStoriesLoading} />
				<HomeLoungeMood onSurprise={handleSurprise} />
				<CategoryScroll
					tags={tags}
					isLoading={isTagsLoading}
					activeCategory={activeCategory}
					onCategoryChange={setActiveCategory}
				/>
				<HomePersonGrid
					persons={filteredPersons}
					onSelectProfile={setSelectedProfile}
					onReload={handleReloadImage}
					hasMore={hasMore}
					onLoadMore={loadNextPage}
					isLoadingMore={isLoadingMore}
					isLoading={isStoriesLoading}
				/>
			</HomeView>
		</>
	);
};

export default Home;
